// src/components/ui/Textarea.tsx
import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helpText?: string;
  maxLength?: number;
  showCount?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  label, error, helpText, maxLength, showCount, className = '', value, ...props
}) => {
  const currentLength = typeof value === 'string' ? value.length : 0;

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-widest text-neutral-text-secondary">
          {label}
          {props.required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <textarea
        className={`
          w-full rounded-lg border border-neutral-border px-4 py-2.5 text-sm resize-y min-h-[100px]
          placeholder:text-neutral-text-secondary
          focus:outline-none focus:ring-2 focus:ring-teal-light focus:border-teal-light
          disabled:bg-neutral-bg disabled:cursor-not-allowed
          ${error ? 'border-danger focus:ring-danger' : ''}
          ${className}
        `}
        value={value}
        maxLength={maxLength}
        {...props}
      />
      <div className="flex justify-between">
        {error ? (
          <p className="text-xs text-danger">{error}</p>
        ) : helpText ? (
          <p className="text-xs text-neutral-text-secondary">{helpText}</p>
        ) : <span />}
        {showCount && maxLength && (
          <p className="text-xs text-neutral-text-secondary">{currentLength}/{maxLength}</p>
        )}
      </div>
    </div>
  );
};

export default Textarea;